import {Component, input, OnInit} from '@angular/core';

@Component({
  selector: 'app-truncated-text-modal',
  templateUrl: './truncated-text-modal.component.html',
  styleUrls: ['./truncated-text-modal.component.scss'],
})
export class TruncatedTextModalComponent  implements OnInit {

  text = input<string>();
  truncatedTxt = input<string>();
  isTruncated = input<boolean>();

  constructor() { }

  ngOnInit() {}

}
